// Routes owned by the KPI module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const kPIPaths = {
    kpiManage: '/kpi-manage',
    kpiCreate: '/kpi-manage/create',
} as const
